/**
 * Extract a human-readable message from API error JSON.
 * Gateway often returns { error: { code, message, timestamp } }.
 */
export function apiErrorMessage(body: unknown, fallback = 'An error occurred'): string {
  if (body == null) return fallback;
  if (typeof body === 'string' && body.trim()) return body;
  if (typeof body !== 'object') return fallback;

  const o = body as Record<string, unknown>;
  if (typeof o.message === 'string' && o.message.trim()) return o.message;

  const err = o.error;
  if (typeof err === 'string' && err.trim()) return err;
  if (err && typeof err === 'object') {
    const nested = err as Record<string, unknown>;
    if (typeof nested.message === 'string' && nested.message.trim()) return nested.message;
    if (typeof nested.code === 'string' && nested.code.trim()) return nested.code;
  }

  if (typeof o.details === 'string' && o.details.trim()) return o.details;
  return fallback;
}
